import { useState } from "react"
import { useFirestore, useFirestoreCollectionData } from "reactfire"
import { collection, addDoc, serverTimestamp, writeBatch, doc } from "firebase/firestore"

export default function CuotaGlobalModal({ unidadId, onCerrar }) {
  const firestore     = useFirestore()
  const apoderadosRef = collection(firestore, "unidades", unidadId, "apoderados")
  const { data: apoderados } = useFirestoreCollectionData(apoderadosRef, { idField: "id" })

  const [form, setForm]       = useState({ tipo: "mensual", descripcion: "", monto: "" })
  const [guardando, setGuardando] = useState(false)
  const [error, setError]     = useState("")

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(f => ({ ...f, [name]: value }))
    setError("")
  }

  const guardar = async () => {
    if (!form.descripcion.trim())                          { setError("Agrega una descripción."); return }
    if (!form.monto || isNaN(form.monto) || +form.monto <= 0) { setError("Ingresa un monto válido."); return }
    setGuardando(true)
    setError("")

    try {
      const cuotaRef = await addDoc(collection(firestore, "unidades", unidadId, "cuotas"), {
        tipo:        form.tipo,
        descripcion: form.descripcion.trim(),
        monto:       parseFloat(form.monto),
        fecha:       serverTimestamp(),
      })

      const activos = (apoderados || []).filter(a => !a.exento)
      if (activos.length > 0) {
        const batch = writeBatch(firestore)
        activos.forEach(ap => {
          const pagoRef = doc(collection(firestore, "unidades", unidadId, "pagos"))
          batch.set(pagoRef, { cuotaId: cuotaRef.id, apoderadoId: ap.id, estado: "pendiente" })
        })
        await batch.commit()
      }
      onCerrar()
    } catch (err) {
      setError("Error al guardar: " + err.message)
    } finally {
      setGuardando(false)
    }
  }

  const activos = (apoderados || []).filter(a => !a.exento)

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onCerrar()}>
      <div className="modal-box" style={{ maxWidth: 460 }}>
        <button className="modal-cerrar" onClick={onCerrar}>×</button>
        <h2 className="modal-titulo">Nueva cuota</h2>

        <div style={{ background: "var(--verde-suave)", borderRadius: 10, padding: "10px 14px", fontSize: 13, color: "var(--verde)", marginBottom: 20, display: "flex", alignItems: "center", gap: 8 }}>
          <span>👥</span>
          Se asignará a <strong>{activos.length} apoderado{activos.length !== 1 ? "s" : ""}</strong> como <strong>pendiente</strong>.
        </div>

        <div className="form-group">
          <label className="form-label">Tipo</label>
          <div style={{ display: "flex", gap: 10 }}>
            {["mensual", "evento"].map(t => (
              <button
                key={t}
                type="button"
                onClick={() => setForm(f => ({ ...f, tipo: t }))}
                style={{
                  flex: 1, padding: "10px", borderRadius: 10, cursor: "pointer",
                  border: `1.5px solid ${form.tipo === t ? "var(--verde-claro)" : "var(--gris-borde)"}`,
                  background: form.tipo === t ? "var(--verde-suave)" : "var(--blanco)",
                  color: form.tipo === t ? "var(--verde)" : "var(--texto-suave)",
                  fontWeight: form.tipo === t ? 700 : 400, fontSize: 14,
                  fontFamily: "'DM Sans', sans-serif", transition: "all 0.15s",
                }}
              >
                {t === "mensual" ? "📅 Mensual" : "⛺ Evento"}
              </button>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Descripción</label>
          <input
            className="form-input" name="descripcion" value={form.descripcion} onChange={handleChange}
            placeholder={form.tipo === "mensual" ? "Ej: Marzo 2025" : "Ej: Campamento de Verano"}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Monto ($)</label>
          <input className="form-input" name="monto" type="number" min="0" value={form.monto} onChange={handleChange} placeholder="Ej: 5000" />
        </div>

        {error && <div style={{ color: "var(--rojo)", fontSize: 13, marginBottom: 12 }}>⚠ {error}</div>}

        <div className="form-actions">
          <button className="btn-secondary" onClick={onCerrar}>Cancelar</button>
          <button className="btn-primary" onClick={guardar} disabled={guardando}>
            {guardando ? "Creando..." : "Crear cuota"}
          </button>
        </div>
      </div>
    </div>
  )
}
